import React, { useState, useEffect, useCallback } from "react";
import {cargarClientes} from '../../services/apiClientes.js';
import {cargarRamos} from '../../services/apiRamos.js';
import {cargarCompanias} from '../../services/apiCompanias.js';
import '../../styles//form.css';
import '../../styles/botones_dflt.css';

const FiltrosPolizas = ({ onBuscar }) => {
    const [optClientes, setOptClientes] = useState([]);
    const [optCompanias, setOptCompanias] = useState([]);
    const [optRamos, setOptRamos] = useState([]);
    const [filtros, setFiltros] = useState({
        cliente: '-1',
        compania: '-1',
        ramo: '-1',
        fch_ini_ven:'-1',
        fch_fin_ven:'-1'
    });

    const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'compania') {
      setOptRamos([]);
      setFiltros({ ...filtros, [name]: value });
      cargar_Ramos(value);
    }else{
      setFiltros({ ...filtros, [name]: value }); 
    }
  };

    const handleBuscar = () => {
        onBuscar(filtros);
    };
    
    const cargar_Ramos = useCallback (async (compania) => {
        try {
            if (compania) {
                const jsonRamos = await cargarRamos(compania);
                const ramosData = jsonRamos.ramos.map((item) => ({
                    id: item.id,
                    compania: item.compania,
                    nombre: item.nombre,
                }));
                setOptRamos(ramosData);
            } else {
                setOptRamos([]);
            }
        } catch (error) {
            console.error('Error cargando las listas:', error);
        }
    },[]);

    useEffect(() => {
        const fetchData = async () => {
          try {
            const jsonClientes = await cargarClientes(filtros);
            const clientesData = jsonClientes.clientes.map((item) => ({
              id: item.id,
              nombre: item.nombre,
              apellido: item.apellido,
              identificacion: item.cedula_ruc,
              direccion: item.direccion
            }));
            const jsonCompanias = await cargarCompanias(filtros);
            const companiasData = jsonCompanias.companias.map((item) => ({
                id: item.id,
                nombre: item.nombre,
                ruc: item.ruc,
                direccion: item.direccion,
            }));
            setOptClientes(clientesData);
            setOptCompanias(companiasData);
          } catch (error) {
            console.error('Error cargando las listas:', error);
          }
        };
        fetchData();
    },[]);

    return (
        <div className="crud-table-form">
            <div className="container">
                <div className='header-label'>
                <label htmlFor="cliente">Cliente</label>
                <select name="cliente" onChange={handleChange}>
                    <option key='-1' value='-1'>--Seleccione un Cliente--</option>
                    {optClientes.map(opt => (
                        <option key={opt.id} value={opt.id}>{opt.nombre+' '+opt.apellido+' - '+opt.identificacion}</option>
                    ))}
                </select>
                </div>

            <div className='header-label'>
            <label htmlFor="compania">Compañía</label>
            <select name="compania" onChange={handleChange}>
                <option key='-1' value='-1'>--Seleccione una Compañía--</option>
                {optCompanias.map(opt => (
                    <option key={opt.id} value={opt.id}>{opt.nombre+' - '+opt.ruc}</option>
                ))}
            </select>
            </div>
            <div className='header-label'>
                <label htmlFor="ramo">Ramo</label>
                    <select name="ramo" onChange={handleChange}>
                        <option key='-1' value='-1'>--Seleccione un Ramo--</option>
                        {optRamos.map(opt => (
                            <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="container">
                <div className='header-label'>
                    <label htmlFor="fch_ini_ven">Fecha Desde</label>
                    <input type='date' name="fch_ini_ven" placeholder="Fecha Inicio Vencimiento" onChange={handleChange} />
                </div>
                <div className='header-label'>
                    <label htmlFor="fch_fin_ven">Fecha Hasta</label>
                    <input type='date' name="fch_fin_ven" placeholder="Fecha Fin Vencimiento" onChange={handleChange} />
                </div>
            </div>
            <button className='button guardar' onClick={handleBuscar}>Buscar</button>
        </div>
    );
};

export default FiltrosPolizas;